export type ClientFilter = "all" | "discount" | "surcharge" | "onAccount";

/**
 * Кутийките под търсачката в „Клиенти": „Всички", „С отстъпка", „С
 * надбавка" (само ако има такива) и „По сметка" — с броя до всяка.
 * Филтрират списъка заедно с търсенето.
 */
export function ClientFilterChips({
  options,
  value,
  onChange,
}: {
  options: { key: ClientFilter; label: string; count: number }[];
  value: ClientFilter;
  onChange: (filter: ClientFilter) => void;
}) {
  return (
    <div className="flex shrink-0 flex-wrap gap-2">
      {options.map((option) => {
        const active = option.key === value;
        return (
          <button
            key={option.key}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(option.key)}
            className={`inline-flex h-9 cursor-pointer items-center gap-1.5 rounded-[10px] border px-3.5 text-[13px] font-semibold transition-colors ${
              active
                ? "border-pos-accent/40 bg-pos-ready-bg text-pos-accent-ink"
                : "border-pos-line3 bg-pos-card text-pos-ink2 hover:border-pos-ctl"
            }`}
          >
            {option.label}
            <span
              className={`font-pos-mono text-[11px] font-semibold ${
                active ? "text-pos-accent-ink/80" : "text-pos-muted"
              }`}
            >
              {option.count}
            </span>
          </button>
        );
      })}
    </div>
  );
}
